// extracted by mini-css-extract-plugin
export default {"p_tye":"_018e33dcf7","slcted":"_6420264442","slc_color":"_61d308be83","item_p":"_64713d64f5","r0":"be13cdcd9a"};